export const API_URL = import.meta.env.VITE_API_URL;
export const AUTH_URL = import.meta.env.VITE_AUTH_URL;
/** Vite build mode: "production" (npm run build), "staging" (build:staging), "development". */
export const APP_ENVIRONMENT = import.meta.env.MODE;

export const isProduction = (env: string | null | undefined) => env === 'production';

/** "Production", "Local" (a developer's own machine), else "Stage". */
export const environmentLabel = (env: string | null | undefined) => {
  if (isProduction(env)) return 'Production';
  return env === 'development' ? 'Local' : 'Stage';
};
/** Browser Google Maps key for the Demos area map (SF-4651); optional, the map says when unset. */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
